import { Phone, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { insuranceLinks } from "./insuranceLinks";
import { useAuthState } from "@/hooks/useAuthState";
import { UserMenu } from "./UserMenu";
import { useIsMobile } from "@/hooks/use-mobile";

interface MobileMenuProps {
  isOpen: boolean;
}

const MobileMenu = ({ isOpen }: MobileMenuProps) => {
  const { isAuthenticated } = useAuthState();
  const isMobile = useIsMobile();

  if (!isOpen || !isMobile) return null;

  return (
    <div className="mt-4 bg-white/90 backdrop-blur-sm rounded-lg overflow-hidden">
      <div className="flex flex-col space-y-4 py-4">
        <Link
          to="/about"
          className="text-neutral hover:text-primary transition px-4"
        >
          About
        </Link>
        {insuranceLinks.map((item) => (
          <Link
            key={item.title}
            to={item.href}
            className="flex items-center space-x-2 text-neutral hover:text-primary transition px-4"
          >
            <item.icon className="h-5 w-5" />
            <span>{item.title}</span>
          </Link>
        ))}
        <Link
          to="/quote"
          className="text-neutral hover:text-primary transition px-4"
        >
          Quote
        </Link>
        {isAuthenticated ? (
          <UserMenu variant="mobile" />
        ) : (
          <Link
            to="/auth"
            className="flex items-center text-neutral hover:text-primary transition px-4"
          >
            <UserRound size={24} />
          </Link>
        )}
        <a 
          href="tel:217-909-9777" 
          className="flex items-center justify-center space-x-2 bg-primary text-white px-6 py-2 mx-4 rounded-lg hover:bg-primary-dark transition"
        >
          <Phone size={18} />
          <span>217-909-9777</span>
        </a>
      </div>
    </div>
  );
};

export default MobileMenu;